import { Button, Result, Spin } from "antd";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const resolveDocUrl = async (urlOrPath: string) => {
  if (!urlOrPath) return "";
  if (/^https?:\/\//i.test(urlOrPath) || urlOrPath.startsWith("blob:")) {
    return urlOrPath;
  }

  return getDownloadURL(ref(getStorage(), urlOrPath));
};

export const DocDisplay = () => {
  const loc = useLocation();
  const nav = useNavigate();
  const state = loc.state as { url?: string; title?: string } | null;

  const [resolvedUrl, setResolvedUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadUrl = async () => {
      try {
        setLoading(true);
        setError(null);

        const sourceUrl = state?.url || "";
        if (!sourceUrl) {
          setError("No document URL was supplied.");
          return;
        }

        setResolvedUrl(await resolveDocUrl(sourceUrl));
      } catch (err) {
        console.error("Failed to resolve document URL:", err);
        setError("Unable to load this document.");
      } finally {
        setLoading(false);
      }
    };

    loadUrl();
  }, [state?.url]);

  return (
    <div className="min-h-screen w-full bg-[#1f1e23] text-white">
      <div className="flex h-screen flex-col">
        <div className="flex items-center justify-between border-b border-white/10 bg-[#1D1928]/80 px-4 py-3 backdrop-blur-sm">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#5C6B73]">
              {"// library.document"}
            </p>
            <h1 className="font-oswald text-xl uppercase tracking-tight text-[#F6B34B]">
              {state?.title || "Document"}
            </h1>
          </div>
          <Button onClick={() => nav("/library")}>Back to Library</Button>
        </div>

        <div className="min-h-0 flex-1 bg-white">
          {loading && (
            <div className="flex h-full items-center justify-center bg-[#1f1e23]">
              <Spin size="large" />
            </div>
          )}

          {!loading && error && (
            <div className="flex h-full items-center justify-center bg-[#1f1e23] p-6">
              <Result
                status="warning"
                title={<span style={{ color: "white" }}>{error}</span>}
                extra={<Button onClick={() => nav("/library")}>Back</Button>}
              />
            </div>
          )}

          {!loading && !error && resolvedUrl && (
            <iframe
              title={state?.title || "Library document"}
              src={resolvedUrl}
              className="h-full w-full border-0"
            />
          )}
        </div>
      </div>
    </div>
  );
};
